import { API_ENDPOINT, API_URL } from '@/api/constant';
import CommonDonutChart from './Chart/CommonDonutChart';
import MainHeading from './MainHeading';
import TodayAttendence from './TodayAttendence';
import { callApi, IApiErrorResponse } from '@/api/callApi';
import { useEffect, useState } from 'react';
import PolicyModal from '../Modal/PolicyModal';
import { getFilterUrl, showToastNotification } from '@/utility/helper';
import DashboardEventCard from './DashboardEventCard';
import { useSelector } from 'react-redux';
import { AppDispatch, RootState } from '@/redux/store';
import { useDispatch } from 'react-redux';
import { fetchUserDetails } from '@/redux/features/UserSlice';
import FullPageLoader from '../loader/FullPageLoader';
import {
  ILeaveItem,
  ITableData,
  ITeamLeaveResponse,
} from '@/interfaces/leave.model';
import {
  IAttendanceRegularization,
  IAttendanceRegularizationResponse,
} from '@/interfaces/regularization.model';
import {
  ITeamWfh,
  ITeamWfhResponse,
  IWFHTableData,
} from '@/pages/HRM/WFH/TeamWfh';
import CommonTable, { ITableColumn } from './CommonTable';
import CardLayout from '../Layout/CardLayout';
import moment from 'moment';
import ViewIcon from '../Icons/ViewIcon';
import { RoutesLink } from '@/utility/RouteLinks';
import { useNavigate } from 'react-router-dom';
import { IArTableData } from '@/pages/HRM/Regularization/TeamRegularization.tsx';
import { calculateDaysDifference } from '@/utility/CommonFunctions';
import ScrollToTop from '@/utility/ScrollToTop';
// import moment from 'moment';
// interface IUserProfileResponse {
//   data: {
//     isVerified: boolean;
//   };
// }
export interface IEmployeeBirthday {
  id: string;
  name: string;
  joiningDate?: string;
  dob: string;
  profilePhoto: string;
  yearCount?: number | string;
}
interface IBirthDayWorkResponse {
  status: boolean;
  data: {
    employeesBirthday: IEmployeeBirthday[];
    employeesWorkAnniversary: IEmployeeBirthday[];
  };
}
interface IDashboardPageState {
  dashboardData: [];
  birthdayList: IEmployeeBirthday[];
  anniversaryList: IEmployeeBirthday[];
  pendingLeave: ITableData[];
  pendingAR: IArTableData[];
  pendingWFH: IWFHTableData[];
  tableLoader: boolean;
}

export interface ILeaveCountItem {
  total?: number;
  pending?: number;
  approved?: number;
  rejected?: number;
}
export interface ILeaveCountResponse {
  status: boolean;
  message: string;
  data: {
    leave: ILeaveCountItem;
    arRequest: ILeaveCountItem;
    odRequest: ILeaveCountItem;
  };
}
interface ILeaveState {
  leavesData: ILeaveCountItem;
  ArData: ILeaveCountItem;
  OdData: ILeaveCountItem;
}
const UserDashboard = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [dataLoading, setDataLoading] = useState<boolean>(false);
  const userDetails = useSelector((state: RootState) => state?.user?.user);
  const [modal, setModal] = useState<boolean>(false);
  const navigate = useNavigate();
  const [state, setState] = useState<ILeaveState>({
    leavesData: {},
    ArData: {},
    OdData: {},
  });
  const [pageStates, setPageStates] = useState<IDashboardPageState>({
    dashboardData: [],
    birthdayList: [],
    anniversaryList: [],
    pendingLeave: [],
    pendingAR: [],
    pendingWFH: [],
    tableLoader: false,
  });
  const wfhTableHeading: ITableColumn<IWFHTableData>[] = [
    { value: 'index', label: '#' },
    { value: 'empNameWithImage', label: 'Employee' },
    { value: 'employeeDept', label: 'Department.' },
    { value: 'siteName', label: 'Office' },
    { value: 'appliedOn', label: 'Appllied Date' },
    { value: 'startDate', label: 'Start Date' },
    { value: 'endDate', label: 'End Date' },
    { value: 'days', label: 'Days' },
    { value: 'status', label: 'Status' },
  ];
  const leaveTableHeading: ITableColumn<ITableData>[] = [
    { value: 'index', label: '#' },
    { value: 'empNameWithImage', label: 'Emp. Name' },
    { value: 'employeeCode', label: 'Emp. Code' },
    { value: 'employeeDept', label: 'Emp. Dept.' },
    { value: 'officeName', label: 'Office' },
    { value: 'leaveType', label: 'Leave Type' },
    { value: 'appliedOn', label: 'Applied On' },
    { value: 'fromDate', label: 'From' },
    { value: 'toDate', label: 'To' },
    { value: 'days', label: 'Days' },
    { value: 'leaveStatus', label: 'Status' },
  ];
  const arTableHeading: ITableColumn<IArTableData>[] = [
    { value: 'index', label: '#' },
    { value: 'empNameWithImage', label: 'Employee' },
    { value: 'officeName', label: 'Office' },
    { value: 'appliedOn', label: 'Created On' },
    { value: 'startDate', label: 'Start Date' },
    { value: 'endDate', label: 'End Date' },
    { value: 'checkInTime', label: 'Check In' },
    { value: 'checkOutTime', label: 'Check Out' },
    { value: 'attendanceStatus', label: 'Attendance' },
    { value: 'status', label: 'Status' },
  ];
  const wfhActionData = [
    {
      label: 'View',
      className: 'btn btn-link',
      icon: <ViewIcon />,
      title: 'view',
      clickHandler: (data: IWFHTableData) =>
        navigate(`${RoutesLink?.wfhTeamRequestDetail}/${data?.id}`),
    },
  ];
  const leaveActionData = [
    {
      label: 'View',
      className: 'btn btn-link',
      icon: <ViewIcon />,
      title: 'view',
      clickHandler: (data: ITableData) =>
        navigate(`${RoutesLink?.leaveTeamDetail}/${data?.id}`, {
          state: { type: 'teamLeaveRequest' },
        }),
    },
  ];
  const arActionData = [
    {
      label: 'View',
      className: 'btn btn-link',
      icon: <ViewIcon />,
      title: 'view',
      isShow: 'always',
      clickHandler: (data: IArTableData) => {
        navigate(`${RoutesLink.arTeamRequestDetail}/${data?.id}`);
      },
    },
  ];
  useEffect(() => {
    if (userDetails?.isVerified === false && userDetails?.type === 0) {
      setModal(true);
    }
  }, [userDetails]);

  useEffect(() => {
    getBirthdayAnniversary();
    getLeaveCount();
    getPendingLists();
  }, []);

  const getLeaveCount = async () => {
    try {
      setDataLoading(true);
      const url = API_URL + API_ENDPOINT?.getLeaveCount + `?type=fromDashboard`;
      const res: ILeaveCountResponse = await callApi(url, {
        method: 'GET',
      });

      if (res?.status === true) {
        setState((pre) => ({
          ...pre,
          leavesData: res?.data?.leave,
          ArData: res?.data?.arRequest,
          OdData: res?.data?.odRequest,
        }));
      } else {
        showToastNotification('danger', res?.message);
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setDataLoading(false);
    }
  };

  const getPendingLists = async () => {
    try {
      const filter = { status: 0, pageSize: 5, pageNumber: 1 };
      const commonQuery = '?' + getFilterUrl(filter);
      const leaveRes: ITeamLeaveResponse = await callApi(
        API_URL + API_ENDPOINT.getLeave + commonQuery,
        { method: 'GET' },
      );
      const arRes: IAttendanceRegularizationResponse = await callApi(
        API_URL + API_ENDPOINT.getAr + commonQuery,
        { method: 'GET' },
      );
      const wfhRes: ITeamWfhResponse = await callApi(
        API_URL + API_ENDPOINT.getWfh + commonQuery,
        { method: 'GET' },
      );
      setPageStates((prev) => ({
        ...prev,
        pendingLeave:
          leaveRes?.data?.leave?.map((item: ILeaveItem, index) => {
            const days =
              Number(
                calculateDaysDifference(
                  item?.startDate,
                  item?.endDate,
                  'number',
                ),
              ) || 0;
            const result =
              item?.leaveDuration == 'firstHalf' ||
              item?.leaveDuration == 'secondHalf'
                ? days * 0.5
                : days;
            return {
              ...item,
              index: index + 1,
              employeeCode: item?.user?.employeeCode,
              empNameWithImage:
                item?.user?.name + '##' + item?.user?.profilePhoto,
              employeeDept: item?.user?.department?.name ?? '--',
              officeName: item?.user?.site?.name ?? '--',
              siteName: item?.user?.usersites?.[0]?.site?.name ?? '',
              appliedOn: moment(item?.createdAt).format('DD/MM/YYYY'),
              fromDate: moment(item.startDate).format('DD/MM/YYYY'),
              toDate: moment(item.endDate).format('DD/MM/YYYY'),
              days: result ? Number(result) : '--',
              leaveStatus: item?.status,
            };
          }) || [],
        pendingAR:
          arRes?.data?.attendance?.map(
            (item: IAttendanceRegularization, index) => ({
              ...item,
              index: index,
              empNameWithImage:
                item?.user?.name + '##' + item?.user?.profilePhoto,
              officeName: item?.user?.site?.name ?? '--',
              //   siteName: item?.user?.usersites?.[0]?.site?.name,
              appliedOn: moment(item?.createdAt).format('DD/MM/YYYY'),
              startDate: moment(item?.checkInTime).format('DD/MM/YYYY'),
              endDate: moment(item?.checkOutTime).format('DD/MM/YYYY'),
              checkInTime:
                item.checkInTime &&
                moment.utc(item.checkInTime).format('hh:mm A'),
              checkOutTime:
                item.checkOutTime &&
                moment.utc(item.checkOutTime).format('hh:mm A'),
              attendanceStatus: item?.status,
              status: item?.arRequestStatus,
            }),
          ) || [],
        pendingWFH:
          wfhRes?.data?.odRequest?.map((item: ITeamWfh, index) => {
            const days =
              Number(
                calculateDaysDifference(
                  item?.startDate,
                  item?.endDate,
                  'number',
                ),
              ) || 0;
            const result =
              item?.wfhDuration == 'firstHalf' ||
              item?.wfhDuration == 'secondHalf'
                ? days * 0.5
                : days;
            return {
              id: item?.id,
              index: index,
              empNameWithImage:
                item?.user?.name + '##' + item?.user?.profilePhoto,
              employeeDept: item?.user?.department?.name ?? '--',
              days: result ? Number(result) : '--',
              officeName: item?.user?.site?.name,
              siteName: item?.user?.site?.name ?? '--',
              appliedOn: moment(item?.createdAt).format('DD/MM/YYYY'),
              startDate: moment(item?.startDate).format('DD/MM/YYYY'),
              endDate: moment(item?.endDate).format('DD/MM/YYYY'),
              status: item?.status,
            };
          }) || [],
      }));
    } catch (error) {
      console.error('Error fetching pending lists:', error);
    }
  };

  const getBirthdayAnniversary = async () => {
    try {
      const API = `${API_URL}${API_ENDPOINT.getBirthdayAnniversary}`;
      const response: IBirthDayWorkResponse = await callApi(API, {
        method: 'GET',
      });

      if (response?.status === true) {
        setPageStates((prev) => ({
          ...prev,
          birthdayList: response?.data?.employeesBirthday,
          anniversaryList: response?.data?.employeesWorkAnniversary,
        }));
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    }
  };

  const handlePolicyAgree = async () => {
    try {
      setIsLoading(true);
      const API = `${API_URL}${API_ENDPOINT?.verification}`;
      await callApi(API, {
        method: 'GET',
      });
      dispatch(fetchUserDetails());
      setModal(false);
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <ScrollToTop dependency={dataLoading} />
      {!userDetails?.isVerified && userDetails?.type === 0 ? (
        <PolicyModal
          isOpen={modal}
          onAgree={handlePolicyAgree}
          isLoading={isLoading}
        />
      ) : (
        <div className="content">
          {dataLoading ? (
            <FullPageLoader />
          ) : (
            <>
              <MainHeading title={'Dashboard'} />
              <div className="row dash-cards row-gap-3">
                <TodayAttendence />
                <CommonDonutChart
                  data={state?.leavesData}
                  heading="Leave"
                  colors={['#1E88E5', '#26A69A', '#5E35B1']}
                />
                <CommonDonutChart
                  data={state?.ArData}
                  heading={'Regularisation'}
                  colors={['#42A5F5', '#66BB6A', '#7E57C2']}
                />
                <CommonDonutChart
                  data={state?.OdData}
                  heading={'Work from Home'}
                  colors={['#0E7490', '#34D399', '#64748B']}
                />
                <div className="col-12 col-lg-12">
                  <div className="row">
                    <DashboardEventCard
                      title={'Birthday'}
                      birthdayList={pageStates?.birthdayList}
                    />
                    <DashboardEventCard
                      title={'Work Anniversary'}
                      workList={pageStates?.anniversaryList}
                    />
                    {(userDetails?.designation?.canAccessTeam ||
                      userDetails?.type === 1) && (
                      <>
                        <CardLayout
                          cardStyle=" mb-4"
                          isGrid={false}
                          isViewAll={pageStates?.pendingWFH?.length > 0}
                          redirect={RoutesLink?.teamWfh}
                          heading={'Pending Work from Home'}
                        >
                          <CommonTable<IWFHTableData>
                            tableHeading={wfhTableHeading}
                            totalPages={1}
                            count={0}
                            currentPage={1}
                            pageSize={5}
                            ActionData={wfhActionData}
                            tableData={pageStates?.pendingWFH}
                            isLoading={pageStates?.tableLoader}
                          />
                        </CardLayout>
                        <CardLayout
                          isGrid={false}
                          isViewAll={pageStates?.pendingLeave?.length > 0}
                          redirect={RoutesLink?.teamLeave}
                          heading="Pending Leave"
                        >
                          <CommonTable
                            tableHeading={leaveTableHeading}
                            tableData={pageStates?.pendingLeave}
                            ActionData={leaveActionData}
                            pageSize={5}
                            totalPages={1}
                            currentPage={1}
                            count={0}
                            isLoading={pageStates?.tableLoader}
                          />
                        </CardLayout>
                        <CardLayout
                          isGrid={false}
                          isViewAll={pageStates?.pendingAR?.length > 0}
                          redirect={RoutesLink?.teamAr}
                          heading="Pending Regularisation"
                        >
                          <CommonTable<IArTableData>
                            ActionData={arActionData}
                            tableHeading={arTableHeading}
                            tableData={pageStates?.pendingAR}
                            currentPage={1}
                            isLoading={pageStates?.tableLoader}
                            totalPages={1}
                            count={0}
                            pageSize={5}
                          />
                        </CardLayout>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default UserDashboard;
